import CONSTANTS from "./CONSTANTS";
import actions from "./actions";
import { toast } from "react-toastify";
import { all, fork, put, select, takeLatest } from "redux-saga/effects";
import constants from "./CONSTANTS";
import mainAxios from "src/settings/axios";
import { map } from "lodash";

export const POLICIES_URL = '/services/rcp/profile/common/';

export function* getPrivacyPolicies() {
  yield takeLatest(CONSTANTS.GET_PRIVACY_POLICIES, function* () {
    try {
      yield put(actions.setPrivacyPolicies(null));

      const url = POLICIES_URL + "GetPrivacyPolicies";
      const res = yield window.mainAxios.get(url).then(r => r.data);
      
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success) throw {
        errorCode: res.errorCode,
        errorMessage: res.errorMessage
      }

      const data = res.data;

      yield put(actions.setPrivacyPolicies(data));
    } catch (e) {
      yield put(actions.setPrivacyPolicies(null));
      console.error(e);
    }
  });
}


// Exporting all sagas as 1 root saga
export default function* rootSaga() {
  yield all([
    fork(getPrivacyPolicies),
  ]);
}
